import * as R from 'ramda'
import { createActions } from 'redux-actions'

const actions = createActions({
  CORE: {
    TOKEN: {
      SET: undefined
    },
    KEYCLOAK: {
      REALM: {
        SET: undefined,
        CLEAR: undefined
      }
    },
    PROFILE: {
      UPDATING: undefined,
      UPDATE: {
        SUCCEEDED: undefined,
        FAILED: undefined
      }
    },
    PASSWORD: {
      RESETTING: undefined,
      RESET: {
        SUCCEEDED: undefined,
        FAILED: undefined
      }
    },
    REQUESTER: {
      FETCH: (client, userId) => {
        return client
          .request({
            url: `/users/${userId}`
          })
          .then(R.prop('data'))
      },
      UPDATE: (client, userId, data) => {
        return client
          .request({
            method: 'PUT',
            url: `/users/${userId}`,
            data
          })
          .then(R.prop('data'))
      }
    },
    MIDS: {
      SET: undefined
    },
    MID: {
      SET: undefined
    },
    STORED_ORDER: {
      SET: undefined,
      GET: undefined,
      DELETE: undefined
    },
    IS_PARTNER: {
      SET: undefined
    }
  }
}).core

export default actions
